<ol class="list-group list-group-numbered">
    <li class="list-group-item d-flex justify-content-between align-items-start" *ngFor="let history of bitacora">
        <div class="ms-2 me-auto">
            <div class="fw-bold">{{history.accion}}</div>  
            {{history.usuario}} 
            <label>Inicio: {{history.fecha}} | Fin: {{history.fechaFin}}</label> 
        </div>
        <span class="badge text-bg-success rounded-pill"><i _ngcontent-lag-c86="" class="fa-truck fas">{{history.proceso}}</i></span>
    </li>
</ol>